export const KuwaitPlate = ({ adm, plate, size = "lg" }) => {
  const big = size === "lg";
  const len = String(plate || "").length;
  const ps = big ? (len <= 5 ? "text-[44px]" : len <= 6 ? "text-[29px]" : "text-[24px]") : "text-xl";
  return (
    <div className={`inline-flex max-w-full bg-white text-black border-[3px] border-black rounded-xl shadow-lg overflow-hidden ${big ? "h-[100px]" : "h-[46px]"}`} dir="ltr" data-testid="kuwait-plate">
      <div className={`flex flex-col items-center justify-center border-r-[3px] border-black font-black leading-none ${big ? "px-1.5 text-[11px] gap-[2px]" : "px-0.5 text-[6px]"}`}>
        {"KUWAIT".split("").map((c, i) => <span key={i}>{c}</span>)}
      </div>
      <div className={`flex flex-col justify-center min-w-0 ${big ? "px-2" : "px-1.5"}`}>
        <div className={`flex items-center justify-between ${big ? "gap-2" : "gap-1"}`}>
          <span className={`font-black leading-none ${big ? "text-2xl" : "text-sm"}`}>{adm}</span>
          <span className={`font-bold leading-none whitespace-nowrap ${big ? "text-sm" : "text-[8px]"}`} dir="rtl">دولة الكويت</span>
        </div>
        <span className={`font-black tracking-wider leading-none ${ps} ${big ? "mt-1" : ""}`} style={{ fontFamily: "'Arial Black', Arial, sans-serif" }}>{plate}</span>
      </div>
    </div>
  );
};
